import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AppSmartBanner.css';

// Thumbtack-style "Get the app" smart banner: a sticky, dismissible bottom bar
// shown to mobile web visitors, device-aware (iOS → App Store, Android → Play),
// reusing /get-app (which redirects to the right store + carries the deferred
// deep-link referrer on Android). Hidden on desktop, on /siteadmin, and for 7
// days after a dismiss (cookie). SSR-safe: renders null until mounted.
const DISMISS_COOKIE = 'bh_app_banner_dismissed';

function getCookie(name) {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : '';
  } catch (e) { return ''; }
}
function setCookie(name, value, days) {
  try {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/`;
  } catch (e) { /* ignore */ }
}

class AppSmartBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { show: false, platform: '' };
    this.dismiss = this.dismiss.bind(this);
  }

  componentDidMount() {
    try {
      const ua = navigator.userAgent || '';
      const isIOS = /iPhone|iPad|iPod/i.test(ua);
      const isAndroid = /Android/i.test(ua);
      if (!isIOS && !isAndroid) return; // desktop → nothing
      const path = (window.location.pathname || '');
      // Don't nag inside the admin panel or the get-app page itself.
      if (path.startsWith('/siteadmin') || path.startsWith('/get-app')) return;
      if (getCookie(DISMISS_COOKIE) === '1') return;
      this.setState({ show: true, platform: isIOS ? 'ios' : 'android' });
    } catch (e) { /* ignore */ }
  }

  dismiss() {
    setCookie(DISMISS_COOKIE, '1', 7);
    this.setState({ show: false });
  }

  // Carry pro + service from a /pro/<id> page into /get-app so the deferred
  // deep link (Android) lands the user back on that pro after install.
  hrefForGetApp() {
    try {
      const path = window.location.pathname || '';
      const m = path.match(/^\/pro\/([^/?#]+)/);
      if (m && m[1]) {
        const svc = new URLSearchParams(window.location.search).get('service');
        return `/get-app?pro=${encodeURIComponent(m[1])}${svc ? `&service=${encodeURIComponent(svc)}` : ''}`;
      }
    } catch (e) { /* ignore */ }
    return '/get-app';
  }

  render() {
    if (!this.state.show) return null;
    const isIOS = this.state.platform === 'ios';
    return (
      <div className={s.bar} role="complementary" aria-label="Get the BestHand app">
        <button type="button" className={s.close} onClick={this.dismiss} aria-label="Dismiss">×</button>
        <div className={s.logo}>B</div>
        <div className={s.txt}>
          <div className={s.title}>Get the BestHand app</div>
          <div className={s.sub}>Book trusted pros faster {isIOS ? '· on the App Store' : '· on Google Play'}</div>
        </div>
        <a className={s.cta} href={this.hrefForGetApp()}>{isIOS ? 'App Store' : 'Get it'}</a>
      </div>
    );
  }
}

export default withStyles(s)(AppSmartBanner);
